import {CountryRegionQuery, LocationQuery} from "@feg/ui";

export const getCountryRegionNested = (row: LocationQuery['location'][number] | CountryRegionQuery['country_region'][number]) => {
    const firstLevel = row.country_region
    const secondLevel = firstLevel?.country_region
    const thirdLevel = secondLevel?.country_region
    const fourthLevel = thirdLevel?.country_region
    return [firstLevel?.name, secondLevel?.name, thirdLevel?.name, fourthLevel?.name].filter(i => i).join(' // ')
}
